var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21146 4.13187H5.02861C4.57146 4.13187 4.20575 3.78022 4.20575 3.34066V0.703297C4.20575 0.351648 4.57146 0 5.02861 0H5.12004C5.57718 0 5.94289 0.351648 5.94289 0.791209V3.42857C5.94289 3.78022 5.57718 4.13187 5.21146 4.13187Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9715 4.13187H10.88C10.4229 4.13187 10.0572 3.78022 10.0572 3.34066V0.703297C10.0572 0.351648 10.4229 0 10.88 0H10.9715C11.4286 0 11.7943 0.351648 11.7943 0.791209V3.42857C11.7943 3.78022 11.4286 4.13187 10.9715 4.13187Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.08 15.3846H2.01145C1.28002 15.3846 0.731445 14.8572 0.731445 14.1539V3.42858C0.731445 2.72529 1.28002 2.19781 2.01145 2.19781H14.08C14.8114 2.19781 15.36 2.72529 15.36 3.42858V14.1539C15.2686 14.7692 14.72 15.3846 14.08 15.3846Z",
    stroke: "#010101",
    strokeWidth: 1.5687,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57142 7.20878C4.97538 7.20878 5.30285 6.8939 5.30285 6.50548C5.30285 6.11706 4.97538 5.80219 4.57142 5.80219C4.16747 5.80219 3.84 6.11706 3.84 6.50548C3.84 6.8939 4.16747 7.20878 4.57142 7.20878Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04573 7.20878C8.44969 7.20878 8.77716 6.8939 8.77716 6.50548C8.77716 6.11706 8.44969 5.80219 8.04573 5.80219C7.64177 5.80219 7.3143 6.11706 7.3143 6.50548C7.3143 6.8939 7.64177 7.20878 8.04573 7.20878Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 7.20878C11.8325 7.20878 12.16 6.8939 12.16 6.50548C12.16 6.11706 11.8325 5.80219 11.4286 5.80219C11.0246 5.80219 10.6971 6.11706 10.6971 6.50548C10.6971 6.8939 11.0246 7.20878 11.4286 7.20878Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57142 10.0219C4.97538 10.0219 5.30285 9.70707 5.30285 9.31865C5.30285 8.93023 4.97538 8.61536 4.57142 8.61536C4.16747 8.61536 3.84 8.93023 3.84 9.31865C3.84 9.70707 4.16747 10.0219 4.57142 10.0219Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04573 10.0219C8.44969 10.0219 8.77716 9.70707 8.77716 9.31865C8.77716 8.93023 8.44969 8.61536 8.04573 8.61536C7.64177 8.61536 7.3143 8.93023 7.3143 9.31865C7.3143 9.70707 7.64177 10.0219 8.04573 10.0219Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 10.0219C11.8325 10.0219 12.16 9.70707 12.16 9.31865C12.16 8.93023 11.8325 8.61536 11.4286 8.61536C11.0246 8.61536 10.6971 8.93023 10.6971 9.31865C10.6971 9.70707 11.0246 10.0219 11.4286 10.0219Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57142 12.7472C4.97538 12.7472 5.30285 12.4324 5.30285 12.0439C5.30285 11.6555 4.97538 11.3406 4.57142 11.3406C4.16747 11.3406 3.84 11.6555 3.84 12.0439C3.84 12.4324 4.16747 12.7472 4.57142 12.7472Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04573 12.7472C8.44969 12.7472 8.77716 12.4324 8.77716 12.0439C8.77716 11.6555 8.44969 11.3406 8.04573 11.3406C7.64177 11.3406 7.3143 11.6555 7.3143 12.0439C7.3143 12.4324 7.64177 12.7472 8.04573 12.7472Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 12.7472C11.8325 12.7472 12.16 12.4324 12.16 12.0439C12.16 11.6555 11.8325 11.3406 11.4286 11.3406C11.0246 11.3406 10.6971 11.6555 10.6971 12.0439C10.6971 12.4324 11.0246 12.7472 11.4286 12.7472Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.68f087f0.svg";
export { ForwardRef as ReactComponent };